<section class="dictamen-listado container py-4">
  <h2>Listado de casos</h2>

  <!-- Filters -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row align-items-end">
        <div class="col-md-3 mb-2">
          <label class="form-label">RUT Funcionario</label>
          <input type="text" class="form-control" [(ngModel)]="filtroRutFuncionario" placeholder="Ej: 12345678"
            (keyup.enter)="onFiltrar()">
        </div>
        <div class="col-md-3 mb-2">
          <label class="form-label">Fecha Ingreso Desde</label>
          <input type="date" class="form-control" [(ngModel)]="filtroFechaDesde">
        </div>
        <div class="col-md-3 mb-2">
          <label class="form-label">Fecha Ingreso Hasta</label>
          <input type="date" class="form-control" [(ngModel)]="filtroFechaHasta">
        </div>
        <div class="col-md-3 mb-2">
          <button class="btn btn-primary mr-2" (click)="onFiltrar()">
            <i class="bi bi-search"></i> Filtrar
          </button>
          <button class="btn btn-secondary" (click)="onLimpiar()">
            <i class="bi bi-eraser"></i> Limpiar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
    <p class="mt-2">Cargando casos...</p>
  </div>

  <div *ngIf="!isLoading && casos.length === 0" class="alert alert-info mt-3">
    No se encontraron casos disponibles para dictamen.
  </div>

  <div class="table-responsive" *ngIf="!isLoading && casos.length > 0">
    <table class="table table-striped mt-3">
      <thead>
        <tr>
          <th>ID</th>
          <th>RUT Funcionario</th>
          <th>Funcionario</th>
          <th>RUT Institución</th>
          <th>Institución</th>
          <th>Fecha ingreso</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of casos">
          <td>{{ c.exp_id }}</td>
          <td>{{ c.exp_rut_fun }}</td>
          <td>{{ c.exp_nombre_fun }} {{ c.exp_apellido_paterno_fun }}</td>
          <td>{{ c.ins_rut }}</td>
          <td>{{ c.ins_nombre }}</td>
          <td>{{ c.exp_fecha_ingreso | date:'dd-MM-yyyy' }}</td>
          <td><span class="badge badge-secondary">{{ c.eex_nombre }}</span></td>
          <td class="text-nowrap">
            <div class="d-flex align-items-center flex-nowrap">
              <!-- Acciones principales -->
              <button *ngIf="canRegisterDictamen(c.eex_codigo) && c.eex_codigo !== 7"
                class="btn btn-sm btn-primary flex-shrink-0 mr-2" (click)="goToRegistrar(c)">
                {{ getButtonText(c.eex_codigo) }}
              </button>

              <!-- Emitir Resolución Button -->
              <button *ngIf="c.eex_codigo === 7" class="btn btn-sm btn-success flex-shrink-0 mr-2"
                (click)="onEmitirResolucion(c)" [disabled]="isLoading">
                <i class="bi bi-file-earmark-check"></i> Ver Resolución
              </button>

              <!-- Trazabilidad: Always visible -->
              <button class="btn btn-sm btn-outline-secondary flex-shrink-0 mr-2"
                [routerLink]="['/expedientes', c.exp_id, 'trazabilidad']">
                <i class="bi bi-clock-history"></i> Trazabilidad
              </button>

              <!-- Cierre Administrativo: Conditional -->
              <button *ngIf="canCierreAdministrativo(c.eex_codigo)" class="btn btn-sm btn-outline-danger flex-shrink-0"
                (click)="onCierreAdministrativo(c)" title="Cierre Administrativo">
                <i class="bi bi-x-circle"></i> Cierre Adm.
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>



</section>